import checkRetractionForErrors from "~/store/manage/validation/checkRetractionForErrors";

const UPDATE_RETRACTION_REQUEST = (state, payload) => {
  state.retractionItem.retraction.request[payload.field] = payload.value;

  state.retractionErrors = checkRetractionForErrors(state.retractionItem);
};

export default UPDATE_RETRACTION_REQUEST;
